import {Dispatch} from "react";
import {EmailConfigurationType} from "./types";
import {fetchEmailContent} from "../../services/api";
import {RenderAlert} from "../../renderer/types";

export type Action = { type: "updateConfiguration", value: EmailConfigurationType } |
    { type: "startUpdate" } |
    { type: "updateCompleted", value: { body: string, alerts: RenderAlert[] } } |
    { type: "updateFailed", value: { error: string | undefined | null, alerts: RenderAlert[] } }


export const updateConfiguration = async (dispatch: Dispatch<Action>, newConfiguration: EmailConfigurationType) => {
  dispatch({type: "updateConfiguration", value: newConfiguration})
  await updateEmail(dispatch, newConfiguration)

}


export const updateEmail = async (dispatch: Dispatch<Action>, configuration: EmailConfigurationType) => {
  dispatch({type: "startUpdate"})
  const result = await fetchEmailContent({
    pageUrl: configuration.pageLink,
    pageConfig: configuration.pageConfig,
    premiumRender: false,
    engine: configuration.pageConfig.renderEngine
  })

  if (result?.body) {
    dispatch({
      type: "updateCompleted",
      value: {
        body: result.body,
        alerts: result.alerts
      }
    })
  } else {
    dispatch({type: "updateFailed", value: {error: result?.error, alerts: result?.alerts || []}})
  }
}

